(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("string-template-parser", [], factory);
	else if(typeof exports === 'object')
		exports["string-template-parser"] = factory();
	else
		root["string-template-parser"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition